export default __webpack_public_path__ + "static/media/Sfc.46e7b3bb.jpg";